module.exports = __webpack_public_path__ + "static/img/10.023d48f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/10.png
// module id = BtoX
// module chunks = 0